// extracted by mini-css-extract-plugin
export default {"variable-suggestion-dropdown":"VariableSuggestion_variable-suggestion-dropdown__vWPv2"};